const updateCategories = (data, ctx) => {
    if (!data === null || data === undefined)
        return;
    const initialData = JSON.parse(ctx.data);
    ctx.categories = initialData.map((c) => {
        // eslint-disable-next-line no-param-reassign
        c.isActive = false;
        return c;
    });
};
const handleDropdown = (ctx, index, isActive, selectType, event) => {
    setTimeout(() => {
        var _a, _b;
        const isLink = (_a = (event && !event.target)) !== null && _a !== void 0 ? _a : false;
        (_b = ctx.categories) === null || _b === void 0 ? void 0 : _b.forEach(c => {
            // eslint-disable-next-line no-unused-expressions
            c !== ctx.categories[index] &&
                selectType === 'custom' &&
                // eslint-disable-next-line no-param-reassign
                (c.isActive = false);
        });
        if (isLink && selectType === 'custom')
            return;
        if (ctx.categories[index].isActive) {
            ctx.categories[index].isActive = false;
        }
        else {
            ctx.categories[index].isActive = isActive;
        }
        ctx.requestUpdate();
    }, 0);
};

export { handleDropdown, updateCategories };
